import useCurrency from '@hooks/useCurrency';

import SourceInsightCard from './SourceInsightCard';

import { SOURCE_INSIGHT_CARD_COPY } from '../../constants/leadSources';
import { LeadSourcesSummary } from '../../types/leadSources';

interface SourceInsightCardsRowProps {
  summary?: LeadSourcesSummary | null;
  isLoading?: boolean;
  isError?: boolean;
  hideSourceLogo?: boolean;
}

const SourceInsightCardsRow = ({
  summary,
  isLoading = false,
  isError = false,
  hideSourceLogo = false
}: SourceInsightCardsRowProps) => {
  const { formatCurrencyValue } = useCurrency();
  const { topVolume, highestConversion, highestRevenue } =
    SOURCE_INSIGHT_CARD_COPY;

  const showEmpty = !isLoading && (isError || !summary);
  const revenueAmount = summary?.highest_revenue?.revenue;
  const revenue =
    revenueAmount != null ? formatCurrencyValue(revenueAmount / 100) : null;

  return (
    <div className="grid w-full grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
      <SourceInsightCard
        title={topVolume.title}
        isLoading={isLoading}
        isEmpty={
          showEmpty || !summary?.top_volume || !summary?.top_volume?.source_id
        }
        sourceName={summary?.top_volume?.name}
        metric={
          summary?.top_volume
            ? `${summary.top_volume.count.toLocaleString()} ${
                topVolume.metricSuffix
              }`
            : undefined
        }
        hideSourceLogo={hideSourceLogo}
      />
      <SourceInsightCard
        title={highestConversion.title}
        isLoading={isLoading}
        isEmpty={
          showEmpty ||
          !summary?.highest_conversion ||
          !summary?.highest_conversion?.source_id
        }
        sourceName={summary?.highest_conversion?.name}
        metricAsPill
        metric={
          summary?.highest_conversion
            ? `${summary.highest_conversion.percentage}% ${highestConversion.metricSuffix}`
            : undefined
        }
        hideSourceLogo={hideSourceLogo}
      />
      <SourceInsightCard
        title={highestRevenue.title}
        isLoading={isLoading}
        isEmpty={
          showEmpty ||
          !summary?.highest_revenue ||
          !summary?.highest_revenue?.source_id
        }
        sourceName={summary?.highest_revenue?.name}
        metricAsPill
        metric={
          revenue ? (
            <span>
              <span className="font-inter">{revenue.symbol}</span>{' '}
              {revenue.value}
            </span>
          ) : undefined
        }
        hideSourceLogo={hideSourceLogo}
      />
    </div>
  );
};

export default SourceInsightCardsRow;
